
import { Component, output, HostListener, DOCUMENT, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';

const ESCAPE = 'Escape';
@Component({
  standalone: true,
  selector: 'webstore-full-screen',
  templateUrl: './full-screen.component.html',
  styleUrls: ['./full-screen.component.scss'],
  imports: [CommonModule]
})
export class FullScreenComponent implements OnInit, OnDestroy {
  private _document = inject<Document>(DOCUMENT);


  IMAGE_URLS = IMAGE_URLS;

  close$ = output<void>();

  onClose() {
    this.close$.emit();
  }
  productName: string = '';

  @HostListener('document:keydown', ['$event']) private handleKeydown(event: KeyboardEvent) {
    if (event.code === ESCAPE) {
      this.close$.emit();
    }
  }

  ngOnInit(): void {
    this.hideOverFlow();
  }

  hideOverFlow() {
    this._document.body.style.setProperty('overflow', 'hidden');
  }

  showOverFlow() {
    this._document.body.style.setProperty('overflow', 'auto');
  }

  ngOnDestroy(): void {
    this.showOverFlow();
  }
}

